<div style="position: relative">
  <div class="pl-container">
    <div>
      <button
        [ngClass]="{ 'is-menu-selected': isMainMenu && !isChefMenu }"
        (click)="navigateTo('/menu')"
      >
        {{ 'menuBar.mainMenu' | translate }}
      </button>
    </div>
  </div>
  <div class="en-container">
    <div>
      <button
        [ngClass]="{ 'is-menu-selected': !isMainMenu && !isChefMenu && !isSeasonMenu }"
        (click)="navigateTo('/menu/alkohole')"
      >
        {{ 'menuBar.alcoholMenu' | translate }}
      </button>
    </div>
  </div>
  <div class="en-container">
    <div>
      <button
        [ngClass]="{ 'is-menu-selected': isChefMenu }"
        (click)="navigateTo('/menu/wybor_konesera')"
      >
        {{ 'menuBar.chefRecommends' | translate }}
      </button>
    </div>
  </div>
  <div class="main-container--row">
    <div
      class="phone-container main-container--row--column main-col-12 justify-center"
    >
      <a href="tel:603900600">
        <img src="./assets/tel%20foot.svg" [alt]="'common.contactPhone' | translate" />
      </a>
    </div>
  </div>
</div>
